import React, { useState } from "react";
import "./IpSummary.scss";
import { formatDate } from "../../../../services/helpFunctions/formatDateAndTime";

const getPosponedStatus = (value) => (value ? "Yes" : "No");

function SiteVisitCards({ projectData }) {
  const [selected, setSelected] = useState(null);

  const cardsData = Array.isArray(projectData?.data?.ipSummarySiteVisitResponse)
    ? projectData.data.ipSummarySiteVisitResponse
    : [];

  // The card widths come from the grid now (auto-filling tracks), so the
  // window-width listener that used to swap flex-basis between 50% and 100% is
  // gone with it.
  const selectedCardKeyInfo = selected
    ? cardsData.find((card) => card.svIdentifier === selected)?.siteVisitKeyInfo
    : null;

  return (
    <div className="ipCardDiv">
      <h2 className="ipCardName">Site Visit Cards</h2>
      <div className="ipCardsLayout">
        <div className="ipCards">
          {cardsData.length === 0 && (
            <span className="ipCardsEmpty">No site visit cards.</span>
          )}
          {cardsData.map((card) => (
            <div
              key={card?.svIdentifier}
              className={`cardIp${
                selected === card?.svIdentifier ? " cardIp--selected" : ""
              }`}
              role="button"
              tabIndex={0}
              onClick={() => setSelected(card?.svIdentifier)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ")
                  setSelected(card?.svIdentifier);
              }}
            >
              <h6 className="ipCardHeadingName">{card?.svIdentifier}</h6>
              <span className="ipCardTextName">
                Address: <span>{card?.address}</span>
              </span>
              <span className="ipCardTextName">
                Location: <span>{card?.location2}</span>
              </span>
              <span className="ipCardTextName">
                IP name: <span>{card?.ipName}</span>
              </span>
            </div>
          ))}
        </div>
        <div className="ipCardList">
          <h3 className="ipCardListTitle">Key info</h3>
          {selectedCardKeyInfo ? (
            <>
              <span className="ipCardTextName">
                Target Visit:{" "}
                <span>{formatDate(selectedCardKeyInfo.plannedVisit)}</span>
              </span>
              <span className="ipCardTextName">
                Postponed Visit:{" "}
                <span>
                  {getPosponedStatus(selectedCardKeyInfo?.posponedVisit)}
                </span>
              </span>
            </>
          ) : (
            <span className="ipCardTextName">
              Select a card to see its key info
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default SiteVisitCards;
